import { FC } from "react";

type ViewStatsProps = {
  data: { [key: string]: string | number | null | undefined };
};

type ToggleColor = {
  error: string;
  total: string;
  failed: string;
  result: string;
  success: string;
  executing: string;
  processing: string;
  successPercentage: string;
  successInExpResTime: string;
};

const toggleColor: ToggleColor = {
  error: "#FF716D",
  total: "#ABC7FF",
  failed: "#FF716D",
  result: "#00D1AF",
  success: "#0A3690",
  executing: "#FFC32E",
  processing: "#FFC32E",
  successPercentage: "#10C9AF",
  successInExpResTime: "#0A3690"
};

const ViewStats: FC<ViewStatsProps> = ({ data }) => {
  const percentageArray = ["successPercentage"];
  const ignoreKeys = ["result"];
  const formatKey = (key: string) => {
    const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);

    return (
      <div className="flex items-center gap-2">
        <div
          className="rounded h-5 w-5"
          style={{
            backgroundColor: toggleColor[key as keyof ToggleColor] || "gray"
          }}
        ></div>
        <span>{capitalizedKey}</span>
      </div>
    );
  };

  if (!data) return null;

  return (
    <div className="flex flex-wrap flex gap-2">
      {Object.entries(data).map(([key, value]) => {
        {
          return (
            !ignoreKeys.includes(key) && (
              <div
                key={key}
                className="flex items-center"
              >
                {formatKey(key)}
                <span>
                  : {value}
                  {percentageArray.includes(key) ? "%" : ""}
                </span>
              </div>
            )
          );
        }
      })}
    </div>
  );
};

export default ViewStats;
